import styled from 'styled-components';

export const Container = styled.div`
  height: calc(100vh - 8rem);
  width: 100%;
  margin-top: 4rem;
  background-color: var(--gray-background);

  @media (max-width: 850px) {
    height: calc(100vh - 4rem);
  }
`;

export const Content = styled.div`
  padding: 1rem 10rem;
  max-width: 100%;
  justify-content: space-between;
  max-height: calc(100vh - 8rem);

  .first-header-line {
    display: flex;
    align-items: center;
    justify-content: space-between;
    max-width: 1400px;
    margin: 0 auto;

    a {
      text-decoration: none;
      background-color: var(--light-blue);
      color: white;
      border: var(--light-blue);
      padding: 0.3rem 1rem;
      font-size: 1rem;
      border-radius: 0.3rem;
      -webkit-box-shadow: rgba(0, 0, 0, 0.3) 0 1px 3px;
      -moz-box-shadow: rgba(0,0,0,0.3) 0 1px 3px;
      box-shadow: rgba(0, 0, 0, 0.3) 0 1px 3px;
    }
  }

  .pages-child {
    margin: 0 auto;
    max-width: 1400px;
  }
  
  .loading {
    display: flex;
    align-items: center;
    gap: 1rem;
  }
  .body {
    margin-top: 1rem;

    .points {
      display: flex;
      margin: 1rem auto;
      gap: 1rem;
      max-width: 1400px;
      justify-content: space-between;
    }
  }

  .scroll-body {
    height: calc(100vh - 30rem);
    overflow: auto;
    padding-right: 0.5rem;
    p {
      text-align: center;
    }
  }

  @media (max-width: 980px) {
    .pages {
      font-size: 1rem;
    }

    .points {
      display: grid !important;
      grid-template-columns: 1fr 1fr;
    }  
  }

  @media (max-width: 720px) {
    padding-left: 2rem;
    padding-right: 2rem;

    .scroll-body {
      width: 100%;
      overflow: unset;
    }

    .points {
      display: flex !important;
      flex-direction: column;
    } 
  }
`;
